<template>
    <div class="page bg-gray">
        <backTitleBar></backTitleBar>
        <div class="content">
            <div class="card">
                <div class="fs-32 color-333">
                    提现金额 <span class="color-org">（满500元可提现）</span>
                </div>
                <div class="flex-center bd-bot mt-30 ofh">
                    <div class="input-pre">¥</div>
                    <input type="number" placeholder="输入金额" class="input" v-model="formItem.amount">
                </div>
                <div class="pd-250 flex-between fs-28">
                    <div class="color-999">可提现余额¥ {{account_entity.withdrawable || 0}}</div>
                    <div class="color-main click" @click="withdrawAll">全部提现</div>
                </div>
            </div>
            <div class="card mt-20" style="padding: 0;">
                <div class="card-title">提现银行</div>
                <div class="pd-020">
                    <div class="input-field bd-bot click" @click="showPop = true">
                        <div class="fs-32 color-333 left required">开户银行 </div>
                        <div class="field-content" :class="formItem.bankName ? 'color-333':'color-999'">{{formItem.bankName || '请选择开户银行'}}</div>
                        <div class="alifont icon-fanhui1 fs-30 color-999 right"></div>
                    </div>
                    <div class="input-field bd-bot">
                        <div class="fs-32 color-333 left required">账号名称</div>
                        <van-field class="input" type="text" :clearable="true" v-model="formItem.bankUname" placeholder="请输入账号名称" />
                    </div>
                    <div class="input-field bd-bot">
                        <div class="fs-32 color-333 left required">银行账户</div>
                        <van-field class="input" type="digit" :clearable="true" v-model="formItem.bankNo" placeholder="请输入银行账户" />
                    </div>
                    <div class="input-field">
                        <div class="fs-32 color-333 left required">开户行地址</div>
                        <van-field class="input" type="text" :clearable="true" v-model="formItem.bankAddress" placeholder="请输入开户行地址" />
                    </div>
                </div>
            </div>
        </div>
        <div class="main-btn click" style="margin: 1.4rem .32rem 0;" @click="submit">
            提交
        </div>

        <van-popup v-model="showPop" position="bottom">
            <van-picker show-toolbar :columns="dicts['bank_code']" value-key="codename"  @cancel="showPop = false" @confirm="onConfirm"  />
        </van-popup>

    </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import {qryShopIncome,withdrawApply,getShopAccountInfo} from "@/api/account"
    import {qryShopDetail} from "@/api/shop"
    import initDict from "@/mixins/initDict"
    import store from "../../store";
    import inputFix from "@/mixins/inputBugFix"
    export default {
        name: "withdraw",
        components:{backTitleBar},
        mixins:[initDict,inputFix],
        data(){
            return {
                formItem:{},
                account_entity:{},
                showPop:false,
                shopId: this.$store.state.user.shopId,
                accountId:''
            }
        },
        created(){
            // 加载数据字典
            let codeList = [
                'bank_code',
            ]
            this.getThisDict(codeList)
            this.getShopIncome();
            this.getDetail();
            //获取accountId
           this.getAccountInfo();
        },
        methods:{
            //获取商家收入统计
            getShopIncome(){
                qryShopIncome({shopId: this.shopId}).then(res=>{
                    this.account_entity = res.data;
                })
            },
            //获取商家详情
            getDetail(){
                qryShopDetail(this.shopId).then(res=>{
                    this.formItem = res.data;
                })
            },
            getAccountInfo(){
                getShopAccountInfo({shopId: this.shopId}).then(res=>{
                    // this.formItem = res.data;
                    this.accountId = res.data.accountId
                })
            },

            //全部提现
            withdrawAll(){
                this.$set(this.formItem,'amount',this.account_entity.withdrawable);
            },


            onConfirm(value){
                this.$set(this.formItem,'bankCode',value.code);
                this.$set(this.formItem,'bankName',value.codename);
                this.showPop = false;
            },

            //确认提交
            submit(){
                let form = this.formItem;
                if(!form.amount || form.amount == 0 || form.amount < 500){
                    this.$toast('提现金额不少于500元');
                    return
                }
                if(form.amount > this.account_entity.withdrawable){
                    this.$toast('提现金额不得大于可提现金额');
                    return
                }
                if(!form.bankName || !form.bankUname || !form.bankNo || !form.bankAddress){
                    this.$toast('请填写完整银行卡信息');
                    return
                }
                let params = {
                    amount: form.amount,
                    bankName: form.bankName,
                    bankCode: form.bankCode,
                    bankUname: form.bankUname,
                    bankNo: form.bankNo,
                    bankAddress: form.bankAddress,
                    shopId:this.shopId,
                    accountId: this.accountId
                }
                let _this = this;
                withdrawApply(params).then(res=>{
                    if(res.code == 0){
                        this.$dialog.alert({
                            message: '提现申请成功，请等待1-3个工作日',
                        }) .then(() => {     //点击确认按钮后的调用
                            _this.$router.go(-1)
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .content{
        padding: .2rem .24rem;
    }
    .card{
        padding: .3rem .24rem 0;
    }
    .input-pre{
        font-size: .72rem;
        line-height: .87rem;
        color: #333;
    }
    .input{
        font-size: .6rem;
        line-height: 1.2rem;
        color: #333;
        flex: 1;
        background: none;
        border: none;
        outline: none;
        padding-left: .1rem;
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// withdraw.vue?18e25221